module.exports = __webpack_public_path__ + "img/9788952214232.b4bcca06.jpg";